import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID } from '@angular/core';
import { ScrollIntoViewIds, ScrollIntoViewService } from '@sdvor/shared/ui';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { ButtonThemes } from '@shared/v2';

@Component({
  selector: 'sd-watch-later',
  imports: [SdvorButtonComponent],
  templateUrl: './watch-later.component.html',
  styleUrls: ['./watch-later.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WatchLaterComponent {
  buttonTypes = ButtonThemes;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    private scrollIntoViewService: ScrollIntoViewService,
  ) {}

  scrollToProductRecommendations(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.scrollIntoViewService.scrollToElement(ScrollIntoViewIds.Recommendations);
    }
  }
}
